import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { captureUtmsFromUrl, getStoredUtms } from '../../lib/utm';

/**
 * UtmCapture: drop-in component (renders nothing), montado una sola vez a
 * nivel global (Layout) para que aplique en todo el sitio.
 *
 * - Si la URL trae utm_* nuevos, reemplaza (atómico) las cookies guardadas.
 * - Si la URL no trae utm_* pero sí hay guardados en cookie, los "pinta" al
 *   final de la URL actual (después de los parámetros que ya traía, p.ej.
 *   unidad/locale) para que se vean en todo el sitio mientras el usuario
 *   navega, y para que el form los pueda mandar tal cual vengan en la URL.
 */
const UtmCapture = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const incoming = captureUtmsFromUrl(location.search);
    if (incoming) return; // la URL ya trae utms frescos, nada que repintar

    const stored = getStoredUtms();
    if (Object.keys(stored).length === 0) return; // no hay nada guardado

    const params = new URLSearchParams(location.search);
    let changed = false;
    Object.entries(stored).forEach(([key, value]) => {
      if (!params.has(key)) {
        params.set(key, value);
        changed = true;
      }
    });

    if (!changed) return;

    navigate(`${location.pathname}?${params.toString()}${location.hash || ''}`, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
};

export default UtmCapture;
